<template>
    <!-- p-menu -->
    <div class="p-menu">
        <div class="p-menu-list p-reset" :header="block.name" v-for="block in blocks" :key="block">
            <div v-show="block.attributes && block.attributes.length > 0">
                <Accordion :activeIndex="activeTab">
                    <AccordionTab :header="block.name">
                        <ul>
                            <li class="p-menuitem border-bottom-1" v-for="item in block.attributes" :key="item.attribute" :draggable="true" @dragstart="setDraggedAttribute(item)">
                                <a class="p-menuitem-link">
                                    <span class="p-menuitem-text">{{ item.label }}</span>
                                </a>
                            </li>
                        </ul>
                    </AccordionTab>
                </Accordion>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, defineProps, computed, watch } from 'vue';
import useBlockComposable from '../../composables/BlockComposable';
import useFormulaBuilderComposable from '../../composables/FormulaBuilderComposable';
import { useAttributeStore } from '../../products/pha/modules/attribute/store';
import { storeToRefs } from 'pinia';

const props = defineProps({
    shared: {
        type: String,
        default: 'Company',
    },
});

const { blocks, getAllBlocks, addUserProfileBlock } = useBlockComposable();
const { setDraggedAttribute } = useFormulaBuilderComposable();
const attributeStore = useAttributeStore();
const { allUserProfileAttributes } = storeToRefs(attributeStore);

const activeTab = ref(0);

const sharedType = computed(() => {
    return props.shared;
});

onMounted(() => {
    loadBlocks();
});

watch(sharedType, () => {
    loadBlocks();
});

const loadBlocks = async () => {
    await getAllBlocks(sharedType.value, { default: true });
    await loadUserProfileAttributes();
};

const loadUserProfileAttributes = async () => {
    // now fetch attributes
    await attributeStore.fetchAllUserProfileAttributes();
    addUserProfileBlock(allUserProfileAttributes.value);
};
</script>

<style scoped>
.p-accordion .p-accordion-content {
    padding: 0 !important;
}
.p-menu {
    padding: 0;
    height: auto;
    width: auto;
    border: none;
    border: 0.5px solid black;
}
</style>
